import { useSeoMeta } from "@unhead/react";
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Zap, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

const NotFound = () => {
  const location = useLocation();

  useSeoMeta({
    title: "404 - Page Not Found | zapMeaCoffee",
    description: "The page you are looking for could not be found. Return to the home page to continue browsing.",
  });

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 p-4">
      <Card className="max-w-md w-full border-2 border-amber-200 shadow-xl">
        <CardContent className="pt-12 pb-12 text-center space-y-6">
          <div className="inline-block">
            <div className="bg-gradient-to-br from-amber-500 to-orange-500 p-6 rounded-3xl shadow-lg">
              <Zap className="h-16 w-16 text-white fill-white" />
            </div>
          </div>

          <div>
            <h1 className="text-6xl font-bold bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent mb-3">
              404
            </h1>
            <p className="text-xl text-gray-600 mb-2">
              Oops! This page doesn't exist
            </p>
            <p className="text-gray-500">
              The page you're looking for could not be found.
            </p>
          </div>

          <Button
            asChild
            className="bg-gradient-to-r from-amber-600 to-orange-600 hover:from-amber-700 hover:to-orange-700 shadow-lg"
            size="lg"
          >
            <Link to="/">
              <Home className="mr-2 h-5 w-5" />
              Return to Home
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
